var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-expansion-panel-content',[_c('template',{slot:"header"},[_c('strong',[_vm._t("question")],2)]),_c('v-card',[_c('v-card-text',[_vm._t("answer")],2)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }